/**
 * @generated SignedSource<<b8a7789b0e8c775099f81593df9df479>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type headerOnelineMenuItemsQuery$variables = Record<PropertyKey, never>;
export type headerOnelineMenuItemsQuery$data = {
  readonly pwaOnelineMenu: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type headerOnelineMenuItemsQuery = {
  response: headerOnelineMenuItemsQuery$data;
  variables: headerOnelineMenuItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "pwaOnelineMenu",
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "scmp_pwa_oneline_menu"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_oneline_menu\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "headerOnelineMenuItemsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "headerOnelineMenuItemsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "006aaf266a03a8edf8a1d939981d48a0",
    "id": null,
    "metadata": {},
    "name": "headerOnelineMenuItemsQuery",
    "operationKind": "query",
    "text": "query headerOnelineMenuItemsQuery {\n  pwaOnelineMenu: appConfig(filter: {entityId: \"scmp_pwa_oneline_menu\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "647d527cf193124a9458c67cf085f830";

export default node;
